import * as React from "react"
import styles from "../../../styles/components/Product/Rating/Rating-tw-styles"
import PropTypes from "prop-types"

const getStars = (ratingArr, starStyle, content) => {
    return ratingArr.map((n,index) => {
        return (
            <span className={starStyle} key={index + 1} data-value={index + 1}>
                {String.fromCharCode(content)}
            </span>
        )
    })
}
const Rating = ({ ratingData, ratingStyle }) => {
    const { rating, star } = styles[ratingStyle]
    const {
        BaseRating: { topStar, bottomStar }
    } = styles
    let maxRating = 5,
        percentage = (ratingData / maxRating) * 100,
        filledStarDecimal = 9733,
        hollowStarDecimal = 9734
    return (
        <div className={rating}>
            <div className={bottomStar}>
                {getStars([...Array(maxRating)], star, hollowStarDecimal)}
            </div>
            <div className={topStar} style={{ width: `${percentage}%` }}>
                {getStars([...Array(maxRating)], star, filledStarDecimal)}
            </div>
        </div>
    )
}
Rating.propTypes={
    ratingData: PropTypes.number,
    ratingStyle: PropTypes.string
}
export default Rating
